import { Box, Divider } from '@mui/material';
import Menu from '@mui/material/Menu';
import type { ComponentProps, FC, MouseEvent, ReactNode } from 'react';
import { useState } from 'react';

import type { ButtonProps } from '~/components/atoms/Button';
import { Button } from '~/components/atoms/Button';
import { DropdownMenuItem } from '~/components/atoms/DropdownMenuItem';
import type { LinkProps } from '~/components/atoms/Link';

type DropdownMenuProps = {
  buttonProps: Exclude<ButtonProps, LinkProps>;
  menuItems: ComponentProps<typeof DropdownMenuItem>[];
  menuProps?: ComponentProps<typeof Menu>;
  header?: ReactNode;
};

export const DropdownMenu: FC<DropdownMenuProps> = ({ buttonProps, menuItems, menuProps, header }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        {...buttonProps}
        aria-controls={open ? 'dropdown-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      />

      <Menu
        id="dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'dropdown-button',
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableScrollLock
        {...menuProps}
      >
        {header && (
          <Box>
            <Box px={2} py={1}>
              {header}
            </Box>
            <Divider sx={{ marginY: 1 }} />
          </Box>
        )}
        {menuItems.map((item) => (
          <DropdownMenuItem key={item.title} {...item} onClose={handleClose} />
        ))}
      </Menu>
    </>
  );
};
